import { CUE_BACKGROUND_COLORS } from '~shared/consts'

type CueColorPickerProps = {
  onClick: (color: string) => void
  disabled?: boolean
  rundownColors?: readonly string[]
}

export function CueColorPicker({
  onClick,
  disabled,
  rundownColors,
}: CueColorPickerProps) {
  return (
    <div className="px-2 pt-2 gap-1 grid grid-cols-6">
      {(rundownColors || CUE_BACKGROUND_COLORS).map((option) => {
        return (
          <button
            key={option}
            disabled={disabled}
            style={{
              backgroundColor: option,
            }}
            className={[
              'w-5 h-5 hover:brightness-125 focus:outline-hidden focus:ring-3 rounded-sm border border-gray-700 overflow-hidden',
              option === 'transparent' ? 'red-crossed' : '',
            ].join(' ')}
            onClick={onClick.bind(null, option)}
          ></button>
        )
      })}
    </div>
  )
}
